// extracted by mini-css-extract-plugin
module.exports = {"container":"DriverAccidentTab_container__1lVVz","buttonContainer":"DriverAccidentTab_buttonContainer__3S83X"};